@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.title {
  font-weight: @bold;
  padding: 10px 15px;
  color: @scan-page--ready-to-scan-title--text-color;
}

.body {
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  align-items: center;
  justify-content: center;
  background-color: @scan-page--ready-to-scan--background-color;
  color: @scan-page--ready-to-scan--text-color;

  .scan-barcode {
    font-size: 48px;
  }

  .type-too {
    padding-top: 24px;
    font-size: 24px;
  }
}
